<template>
  <div>
    <secondHeader />
    <div class="premium_main">
      <sidebar />
      <div class="premium_content">
        <div class="premium_content-title">
        <h2>
            ハートコメント
        </h2>
        <p>色をカスタマイズできます。</p>
        <p>作成したコードをOBSのカスタムCSSに追記してください。</p>
        </div>
        <div class="heart_contents-block">
            <div class="heart_line__left">
                <span class="heart_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="heart_line__left-text">
                    <span class="heart_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center' }"></span>
                    <div class="heart_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor,'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '40px 30px', 'background-position': 'calc(100% - 5px) calc(100% + 10px)'  }">Hello🐟</div>
                </div>
                <span class="heart_line__name" :style="{ 'color': mainColor, 'border-color': mainColor, 'background-color': nameBgColor }">視聴者さん</span>
                <div class="heart_line__left-text">
                    <span class="heart_icon" :style="{ 'background-image': svgBackground2, 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center'}"></span>
                    <span class="heart_text" :style="{ 'background-color': backgroundColor, 'border-color': mainColor, 'color': mainColor, 'background-image': svgBackground, 'background-repeat': 'no-repeat', 'background-size': '40px 30px', 'background-position': 'calc(100% - 5px) calc(100% + 10px)' }">いい天気ですね</span>
                </div>
            </div>
            <div class="heart_editor">
                <div>
                    <label>背景カラー:</label>
                    <input type="color" v-model="backgroundColor" />
                </div>
                <div>
                    <label>メインカラー:</label>
                    <input type="color" v-model="mainColor" />
                </div>
                <div>
                    <label>名前の背景カラー:</label>
                    <input type="color" v-model="nameBgColor" />
                </div>
                <div v-if="YTgeneratedCSS" class="radio-main">
                    <h3>【YouTube用】コピペ用CSS</h3>
                    <textarea id="target" readonly class="m-form-text" v-model="YTgeneratedCSS" />
                    <button @click="copy" class="copy-btn">コピー</button>
                </div>
                <div v-if="TWgeneratedCSS" class="radio-main">
                    <h3>【Twitch用】コピペ用CSS</h3>
                    <textarea id="target" readonly class="m-form-text" v-model="TWgeneratedCSS" />
                    <button @click="copy2" class="copy-btn">コピー</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
export default {
    components: {
        secondHeader,
        sidebar,
    },
  data() {
    return {
      backgroundColor: '#fcbcac',
      mainColor: '#A73121',
      nameBgColor: '#FFF3E2',
      YTgeneratedCSS: '',
      TWgeneratedCSS: '',
    };
  },
  computed: {
    svgBackground() {
      const svgPath = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' opacity='0.2' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath)}")`;
    },
    svgBackground2() {
      const svgPath2 = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      return `url("data:image/svg+xml,${encodeURIComponent(svgPath2)}")`;
    },
  },
  mounted() {
    this.generateCSS();
  },
  methods: {
    generateCSS() {
      const svgPath = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' opacity='0.2' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      const svgPath2 = `<svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0.00 0.00 250.00 226.00'><path fill='${this.mainColor}' d=' M 58.61 0.00 L 69.79 0.00 C 93.04 3.19 111.95 18.02 124.55 37.23 A 0.51 0.50 45.1 0 0 125.40 37.24 C 138.08 18.16 157.05 2.95 180.36 0.00 L 191.56 0.00 C 225.65 4.65 247.28 34.18 250.00 67.21 L 250.00 82.78 C 244.58 152.40 186.69 200.83 126.78 226.00 L 123.16 226.00 C 85.67 210.27 50.29 185.91 26.13 152.91 Q 3.12 121.48 0.00 82.66 L 0.00 67.14 C 2.77 34.25 24.53 4.29 58.61 0.00 Z'></path></svg>`;
      const svgEncoded1 = encodeURIComponent(svgPath);
      const svgEncoded2 = encodeURIComponent(svgPath2);
      this.YTgeneratedCSS = `yt-live-chat-author-chip #author-name{
        color: ${this.mainColor}!important;
        background-color: ${this.nameBgColor}!important;
    }
    yt-live-chat-text-message-renderer #message {
        background-color: ${this.backgroundColor};
        border: 2px solid ${this.mainColor} !important;
        color: ${this.mainColor} !important;
        background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    yt-live-chat-text-message-renderer #message::before{
        background-image: url("data:image/svg+xml,${svgEncoded2}");
    }
      `;
    this.TWgeneratedCSS = `.chat-author__display-name{
    color: ${this.mainColor}!important;
    background-color: ${this.nameBgColor}!important;
    }
    [data-a-target="chat-line-message-body"]{
    background-color: ${this.backgroundColor};
    border: 2px solid ${this.mainColor} !important;
    color: ${this.mainColor} !important;
    background-image: url("data:image/svg+xml,${svgEncoded1}");
    }
    [data-a-target="chat-line-message-body"]::before{
    background-image: url("data:image/svg+xml,${svgEncoded2}");
    }`;
    },
    async copy() {
      await navigator.clipboard.writeText(this.YTgeneratedCSS);
    },
    async copy2() {
      await navigator.clipboard.writeText(this.TWgeneratedCSS);
    },
  },
  watch: {
    backgroundColor() {
      this.generateCSS();
    },
    mainColor() {
      this.generateCSS();
    },
    nameBgColor() {
      this.generateCSS();
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kiwi+Maru&family=Single+Day&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.premium_main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}
.premium_content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}
.premium_content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

.heart_contents-block{
  margin: 18px auto;
}
.m-form-text{
    width: 80%;
  height: 42px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
    height: 32px;
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}
.copy-btn:active {
  transform: scale(0.95);
  background-color: #ccc;
}

  label {
    margin-right: 10px;
  }
  input[type="color"] {
    margin-right: 20px;
  }

.heart_editor{
    margin-top: 24px;
}
  /* コメントプレビュー */

    .heart_line__left-text{
        position: relative;
        width: fit-content;
        min-width: 180px!important;
        max-width: 420px!important;
        padding: 2px!important;
        transform-origin: 0% 0%;
        animation: slideIn 0.5s forwards ease-out;
        margin-top:12px;

        font-family: "Kiwi Maru", serif;
        line-height: 1.8;
        letter-spacing: 0.12em;
    }

    .heart_text {
        position: relative;
        font-weight: bold;
        border-width: 2px;
        border-style: solid;
        border-radius: 10px;
        padding: 12px 24px 12px 24px;
        margin:-5px;
        margin-bottom:0;
        display: block;
        line-height: 1!important;
    }

    .heart_icon {
        position: absolute;
        z-index:2;
        left: 6px;
        top: 40%;
        width: 0.5em;
        height: 0.5em;
    }

  .heart_line__name{
       position: relative;
       z-index: 2;
       top:12px;
        font-size: 10px !important;
        font-weight: bold;
        padding: 0px 8px 0 8px;
        border: 0.3em solid;
        border-radius: 100vh!important;
  }
</style>